import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { States } from '../../../document-data/sub-models/states.model';
import { EstimateStatusesEnum } from '../../../estimate-data/estimate-data.data';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { FriendlyDatePipe } from '../../../shared/pipes/friendly-date/friendly-date.pipe';

@Component({
  selector: 'app-estimate-status',
  templateUrl: './estimate-status.component.html',
  styleUrls: ['./estimate-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstimateStatusComponent implements OnInit, OnChanges {
  @Input() documentState: States;

  statusLabel: string;
  icon: IIcon;

  constructor(
    private _friendlyDatePipe: FriendlyDatePipe,
    private _translateService: TranslateService
  ) {}

  ngOnChanges(changes) {
    if (changes.documentState && this.documentState) {
      const estimateStatus = this.documentState.estimateStatus;

      if (estimateStatus !== EstimateStatusesEnum.pending) {
        const translateKey = `DOCUMENT.ESTIMATE.STATE.${estimateStatus}_ON_DATE`.toUpperCase();
        const estimateDateDone = this._friendlyDatePipe.transform(
          this.documentState.estimateDateDone,
          true
        );

        this.statusLabel = this._translateService.instant(translateKey, {
          date: estimateDateDone,
        });
      } else {
        this.statusLabel = null;
      }

      this.icon =
        estimateStatus === EstimateStatusesEnum.approved
          ? {
              name: 'checkmark',
              size: IconSizesEnum.small,
            }
          : {
              name: 'close',
              size: IconSizesEnum.small,
              customClass: 'declined',
            };
    }
  }

  ngOnInit() {}
}
